<template>
  <v-layout wrap justify-center>
    <ServerError v-if="ServerError" />
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="blue"
      spinner="mini-spinner"
    />
    <v-snackbar
      :timeout="3000"
      :value="true"
      right
      color="red"
      v-model="showsnackbar"
    >
      <span style="font-size: 20px"> {{ msg }}</span>
    </v-snackbar>
    <v-flex xs12 lg11 pt-6>
      <v-layout wrap justify-center>
        <v-flex xs12>
          <v-card
            class="mx-auto elevation-1 pa-6"
            max-width="1088px"
            align="center"
            outlined
          >
            <v-layout wrap justify-space-between>
              <v-flex
                xs12
                sm6
                pb-2
                pb-md-0
                class="text-left nsbold"
                style="font-weight: 700; font-size: 20px"
                >Routes
              </v-flex>
              <!-- <v-flex
                xs12
                sm3
                md4
                lg4
                pb-2
                pb-md-0
                align-self-center
                class="text-left nsregular"
              >
                <v-text-field
                  v-model="keyword"
                  dense
                  class="rounded-xl"
                  label="Search"
                  outlined
                  hide-details
                  clearable
                ></v-text-field>
              </v-flex> -->
            </v-layout>

            <v-layout wrap justify-space-between py-6>
              <v-flex xs12 align-self-center>
                <v-card flat outlined>
                  <v-layout wrap pa-2>
                    <v-flex xs12 sm6 pa-1 align-self-end text-left>
                      <v-text-field
                        dense
                        outlined
                        label="Route"
                        placeholder="Enter Route name"
                        hide-details
                        v-model="routeData.name"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 pa-1 align-self-end text-left>
                      <!-- <v-select
                        dense
                        outlined
                        label="Select place"
                        hide-details
                        :items="placeList"
                        item-text="name"
                        item-value="_id"
                        v-model="initPlace"
                        multiple
                      ></v-select> -->
                      <v-select
                        dense
                        outlined
                        label="Select place"
                        hide-details
                        :items="placeList"
                        item-text="name"
                        item-value="_id"
                        v-model="initPlace"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 align-self-center pa-2 v-if="placeMap">
                      <v-layout wrap v-if="placeMap.length > 0">
                        <v-flex xs12 align-self-center text-left pa-1>
                          <span class="nsbold">Start Point</span>
                        </v-flex>
                        <v-flex
                          xs12
                          pa-1
                          align-self-center
                          v-for="(item, i) in placeMap"
                          :key="i"
                          text-left
                          style="border-left: 3px solid red"
                        >
                          <v-layout wrap>
                            <v-flex pa-1 xs3 sm1 align-self-center text-left>
                              <v-text-field
                                dense
                                outlined
                                hide-details
                                label="Order"
                                v-model="item.order"
                              ></v-text-field>
                            </v-flex>
                            <v-flex pa-1 xs8 sm3 align-self-center text-left>
                              <v-text-field
                                dense
                                outlined
                                hide-details
                                readonly
                                label="Place"
                                v-model="item.name"
                              ></v-text-field>
                            </v-flex>

                            <v-flex pa-1 xs1 sm1 align-self-center text-left>
                              <v-icon
                                class="#000"
                                title="Delete Place"
                                @click.prevent="deleteAndReorder1(i)"
                                >mdi-delete</v-icon
                              >
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs6 sm2 align-self-center text-left pa-1>
                          <span class="nsbold">Stop Point</span>
                        </v-flex>
                        <v-flex xs6 sm2 align-self-center text-left pa-1>
                          <v-btn
                            block
                            @click="reOrder()"
                            small
                            color="#766BC0"
                            dark
                            class="text-none rounded-xl"
                          >
                            <span class="nsbold">Sort Stops</span>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm2 align-self-end pa-1>
                      <v-btn
                        width="100px"
                        dark
                        block
                        color="#766BC0"
                        class="rounded-lg"
                        @click="addRoute()"
                      >
                        <v-icon x-small>mdi-plus</v-icon>
                        <span
                          class="text-left nsregular"
                          style="font-weight: 400; font-size: 12px"
                          >Add Route</span
                        ></v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>

            <v-layout wrap>
              <v-flex xs12 align-self-center>
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">Route Name</th>
                        <th class="text-left">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        class="text-left regular"
                        v-for="(item, i) in sectionList"
                        :key="i"
                      >
                        <td>{{ item._id.name }}</td>
                        <td>
                          <v-layout wrap>
                            <v-flex xs4  pa-1 align-self-center v-if="item">
                              <v-dialog v-model="item.vdialog" width="70%">
                                <template v-slot:activator="{ on, attrs }">
                                  <span v-bind="attrs" v-on="on"
                                    ><v-icon style="cursor: pointer"
                                      >mdi-eye-outline</v-icon
                                    ></span
                                  >
                                </template>

                                <v-card>
                                  <v-toolbar
                                    dark
                                    color="#766BC0"
                                    dense
                                    flat
                                    class="body-2"
                                  >
                                    <v-toolbar-title> Details </v-toolbar-title>
                                  </v-toolbar>

                                  <v-layout wrap pa-4>
                                    <v-flex xs12 align-self-center pa-2>
                                      <span class="nsbold">
                                        {{ item._id.name }}
                                      </span></v-flex
                                    >
                                    <v-flex xs12 align-self-center pa-2>
                                      <span class="nsbold">
                                        Bus Stops :
                                      </span></v-flex
                                    >

                                    <v-flex xs12 align-self-center pa-2>
                                      <v-timeline dense clipped>
                                        <v-timeline-item
                                          fill-dot
                                          color="error"
                                          small
                                          v-for="(sub, s) in item.busRouteMaps"
                                          :key="s"
                                        >
                                          <span>
                                            {{ sub.placeId.name }}
                                          </span>
                                        </v-timeline-item>
                                      </v-timeline>
                                    </v-flex>
                                  </v-layout>

                                  <v-divider></v-divider>

                                  <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                      color="primary"
                                      text
                                      @click="item.vdialog = false"
                                    >
                                      Close
                                    </v-btn>
                                  </v-card-actions>
                                </v-card>
                              </v-dialog>
                            </v-flex>
                            <v-flex xs4 pa-1 align-self-center v-if="item">
                              <span
                                ><v-icon
                                  style="cursor: pointer"
                                  @click="editCurrent(item)"
                                  >mdi-circle-edit-outline</v-icon
                                ></span
                              >
                            </v-flex>
                            <v-flex xs4 pa-1 align-self-center>
                              <span
                                ><v-icon
                                  style="cursor: pointer"
                                  @click="(dialoge = true), (curId = item._id)"
                                  >mdi-delete-outline</v-icon
                                ></span
                              >
                            </v-flex>
                          </v-layout>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>

      <v-dialog width="450px" v-model="dialoge">
        <v-card>
          <v-toolbar dark color="#766BC0" dense flat class="body-2">
            <v-toolbar-title> Confirm Delete </v-toolbar-title>
          </v-toolbar>
          <v-card-text class="pa-4 black--text"
            >Are you sure you want to delete this record?
          </v-card-text>
          <v-card-actions class="pt-3">
            <v-spacer></v-spacer>
            <v-btn
              color="grey"
              text
              class="body-2 font-weight-bold"
              @click="dialoge = false"
              >Cancel</v-btn
            >
            <v-btn
              color="#766BC0"
              class="body-2 font-weight-bold"
              outlined
              @click="deleteSection()"
              >OK</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog max-width="70%" v-model="editdialogue">
        <v-card>
          <v-toolbar dark color="#766BC0" dense flat class="body-2">
            <v-toolbar-title> Edit Details </v-toolbar-title>
          </v-toolbar>
          <v-layout wrap pa-4>
            <v-flex xs12 sm6 align-self-center pa-2>
              <v-text-field
                dense
                hide-details
                outlined
                label="Route name"
                v-model="curItem.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 align-self-center pa-2>
              <v-select
                dense
                outlined
                label="Select place"
                hide-details
                :items="placeList"
                item-text="name"
                item-value="_id"
                v-model="curItem.aPlace"
                @change="curEditPlaceMap(curItem.aPlace)"
              ></v-select>
            </v-flex>

            <v-flex xs12 align-self-center pa-2 v-if="curPlaceMap">
              <v-layout wrap v-if="curPlaceMap.length > 0">
                <v-flex xs12 align-self-center text-left pa-1>
                  <span class="nsbold">Start Point</span>
                </v-flex>
                <v-flex
                  xs12
                  pa-1
                  align-self-center
                  v-for="(item, i) in curPlaceMap"
                  :key="i"
                  text-left
                  style="border-left: 3px solid red"
                >
                  <v-layout wrap>
                    <v-flex pa-1 xs3 sm1 align-self-center text-left>
                      <v-text-field
                        dense
                        outlined
                        hide-details
                        label="Order"
                        v-model="item.order"
                      ></v-text-field>
                    </v-flex>
                    <v-flex pa-1 xs8 sm3 align-self-center text-left>
                      <v-text-field
                        dense
                        outlined
                        hide-details
                        readonly
                        label="Place"
                        v-model="item.name"
                      ></v-text-field>
                    </v-flex>
                    <v-flex pa-1 xs1 sm1 align-self-center text-left>
                      <v-icon
                        class="#000"
                        title="Delete Place"
                        @click.prevent="deleteAndReorder(i)"
                        >mdi-delete</v-icon
                      >
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs6 sm2 align-self-center text-left pa-1>
                  <span class="nsbold">Stop Point</span>
                </v-flex>
                <v-flex xs6 sm2 align-self-center text-left pa-1>
                  <v-btn
                    block
                    small
                    @click="sortEdit()"
                    color="#766BC0"
                    dark
                    class="text-none rounded-xl"
                  >
                    <span class="nsbold">Sort Stops</span>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-card-actions class="pt-3">
            <v-spacer></v-spacer>
            <v-btn
              color="grey"
              text
              class="body-2 font-weight-bold"
              @click="editdialogue = false"
              >Cancel</v-btn
            >
            <v-btn
              color="#766BC0"
              class="body-2 font-weight-bold"
              outlined
              @click="editRouteValidate()"
              >OK</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-layout wrap>
        <v-flex xs12 pt-4>
          <v-pagination
            small
            color="#766BC0"
            v-model="page"
            :length="Pagelength"
          >
          </v-pagination>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      page: 1,
      Pagelength: 0,
      dialoge: false,
      editdialogue: false,
      showsnackbar: false,
      msg: null,
      appLoading: false,
      ServerError: false,
      valid: true,
      routeData: {
        name: null,
        places: [],
      },
      curItem: {},
      sectionList: null,
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        phoneRules: [
          (v) => !!v || "phone is required",
          (v) =>
            (v && v.length <= 10) || "number must be less than 11 characters",
          (v) =>
            (v && v.length >= 10) ||
            "number must be greater than 10 characters",
          (v) => /^\d{10}$/.test(v) || "phone number must be a number",
        ],
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      doManual: false,
      placeList: [],
      placeMap: [],
      orderedMap: [],
      orderedTemp: [],
      initPlace: null,
      curPlaceMap: [],
      serverData: [],
    };
  },
  mounted() {
    this.getPlaces();
    this.getData();
  },
  watch: {
    page() {
      this.getData();
    },
    // keyword() {
    //   this.getData();
    // },
    // routeData: {
    //   handler(val) {
    //     if (val.places) {
    //       this.placeMap = this.placeList.filter((x) =>
    //         val.places.includes(x._id)
    //       );
    //       console.log("fi=",this.placeMap)
    //     }
    //   },
    //   deep: true,
    // },

    initPlace() {
      console.log("Place List=", this.placeList);
      console.log("Selected PlaceID=", this.initPlace);
      var obarray = this.placeList.filter((x) => x._id == this.initPlace);
      console.log("ObAr=", obarray);
      this.placeMap.push(JSON.parse(JSON.stringify(obarray[0])));
      console.log("Place Map=", this.placeMap);
      for (let i = 0; i < this.placeMap.length; i++) {
        this.placeMap[i].order = i + 1;
      }

      // console.log("Init list=", this.placeList);
      // this.orderedMap.push(this.initPlace);
      // var obarray = this.placeList.filter((x) => x._id == this.initPlace);
      // console.log("ob=", obarray);
      // this.placeMap.push(JSON.parse(JSON.stringify(obarray[0])));

      // console.log("fi=", this.placeMap);
      // for (let i = 0; i < this.placeMap.length; i++) {
      //   this.placeMap[i].order = i + 1;
      // }
    },
  },
  methods: {
    ChangeCurrentOrder() {
      // console.log("Changed Order=",this.placeMap)
      this.placeMap = this.placeMap.sort((a, b) => {
        return parseInt(a.order) - parseInt(b.order);
      });

      console.log("Changed Order=", this.placeMap);
    },
    reOrder() {
      console.log("map1=", this.placeMap);
      this.placeMap = this.placeMap.sort((a, b) => {
        return parseInt(a.order) - parseInt(b.order);
      });
      console.log("map2=", this.placeMap);
      this.orderedTemp = this.placeMap.map((x) => x._id);
    },
    getPlaces() {
      this.appLoading = true;
      axios({
        method: "get",
        url: "/bus/admin/places/list",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.placeList = response.data.data;
          } else {
            this.snackbar = true;
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    editCurrent(item) {
      this.curPlaceMap=[]
      this.curItem = item;
      if (item._id) {
        this.curItem.name = item._id.name;
      }
      if (item.busRouteMaps) {
        var placeArr = item.busRouteMaps.map((x) => x.placeId._id);

        this.curItem.places = placeArr;
        console.log("Plac arr=", placeArr);
        for (let p = 0; p < placeArr.length; p++) {
          var cobjarr = this.placeList.filter((x) => placeArr[p] == x._id);
          this.curPlaceMap.push(JSON.parse(JSON.stringify(cobjarr[0])));
        }
        console.log("Editted",this.curPlaceMap)
        for(let k=0;k<this.curPlaceMap.length;k++) {
          this.curPlaceMap[k].order=k+1
        }
        // this.curPlaceMap = this.placeList.filter((x) =>
        //   placeArr.includes(x._id)
        // );
        // for (let i = 0; i < item.busRouteMaps.length; i++) {
        //   for (let j = 0; j < this.curPlaceMap.length; j++) {
        //     if (item.busRouteMaps[i].placeId._id == this.curPlaceMap[j]._id) {
        //       this.curPlaceMap[j].order = i + 1;
        //     }
        //   }
        // }
        // this.sortEdit();
        console.log("Cur pl=", this.curPlaceMap);
      }

      this.editdialogue = true;
    },
    sortEdit() {
      if (this.curPlaceMap.length > 0)
        this.curPlaceMap = this.curPlaceMap.sort((a, b) => {
          return a.order - b.order;
        });
      for (let i = 0; i < this.curPlaceMap.length; i++) {
        if (!this.curPlaceMap[i].order) {
          this.curPlaceMap[i].order = this.curPlaceMap.length;

          this.sortEdit();
        }
      }
    },
    curEditPlaceMap(item) {
      this.sortEdit();
      console.log("item=", item);
      // this.curPlaceMap = this.placeList.filter((x) => item.includes(x._id));

      var obarray = this.placeList.filter((x) => x._id == item);
      console.log("ob=", obarray);
      this.curPlaceMap.push(JSON.parse(JSON.stringify(obarray[0])));
      this.sortEdit();
    },
    deleteAndReorder(i) {
      this.curPlaceMap.splice(i, 1);
      for (let i = 0; i < this.curPlaceMap.length; i++) {
        this.curPlaceMap[i].order = i + 1;
      }
    },
    deleteAndReorder1(i) {
      this.placeMap.splice(i, 1);
      for (let i = 0; i < this.placeMap.length; i++) {
        this.placeMap[i].order = i + 1;
      }
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "get",
        url: "/bus/admin/route/get/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        params: {
          // keyword: this.keyword,
          page: this.page,
          limit: 20,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.sectionList = response.data.data;
            if (response.data.totalLength)
              this.Pagelength = Math.ceil(response.data.totalLength / 20);
          } else {
            this.snackbar = true;
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    //delete button
    deleteSection() {
      axios({
        url: "/bus/admin/remove/trip",
        method: "POST",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          id: this.curId,
        },
      })
        .then((response) => {
          this.delete = false;
          this.dialoge = false;
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Delete Sucessfully";
            // this.$router.go(-1)
            this.showsnackbar = true;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    //add button
    addRoute() {
      this.reOrder();
      this.routeData.places = this.orderedTemp;
      if (!this.routeData.name) {
        this.msg = "All fields are required*";
        this.showsnackbar = true;
        return;
      } else if (this.routeData.places.length <= 0) {
        this.msg = "Please provide places";
        this.showsnackbar = true;
        return;
      } else {
        this.appLoading = true;
        axios({
          url: "/bus/admin/trip/map/places",
          method: "POST",
          headers: {
            token: localStorage.getItem("token"),
          },
          data: this.routeData,
        })
          .then((response) => {
            this.appLoading = false;

            if (response.data.status) {
              this.msg = response.data.msg;
              this.showsnackbar = true;
            } else {
              this.msg = response.data.msg;
              this.showsnackbar = true;
            }

            this.getData();
            this.routeData = {};
          })
          .catch((err) => {
            this.appLoading = false;
            this.ServerError = true;
            console.log(err);
          });
      }
    },
    //edit button
    editRouteValidate() {
      this.sortEdit();
      if (this.curPlaceMap.length > 0) {
        this.serverData = this.curPlaceMap.map((x) => x._id);
      }
      if (!this.curItem.name) {
        this.msg = "Route name must be provided.";
        this.showsnackbar = true;
        return;
      } else if (this.serverData.length <= 0) {
        this.msg = "Places must be provided.";
        this.showsnackbar = true;
        return;
      } else this.editRoute();
    },
    editRoute() {
      {
        axios({
          url: "/bus/admin/trip/edit",
          method: "POST",
          headers: {
            token: localStorage.getItem("token"),
          },
          data: {
            id: this.curItem._id,
            name: this.curItem.name,
            places: this.serverData,
          },
        })
          .then((response) => {
            this.editdialogue = false;
            this.appLoading = false;
            if (response.data.status) {
              this.msg = response.data.msg;
              this.showsnackbar = true;
            } else {
              this.msg = response.data.msg;
              this.showsnackbar = true;
            }
            this.getData();
          })
          .catch((err) => {
            this.appLoading = false;
            this.ServerError = true;
            console.log(err);
          });
      }
    },
  },
};
</script>
<style scoped>
#map44 {
  height: 100%;
}
</style>
